import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { buscaCertidoesLegadas, initFiltro } from "../../service/ConsultarCertidoesLegadas";

import RotuloSeplag from "../../components/RotuloSeplag";
import TableSeplag from "../../components/TableSeplag";
import CardSeplag from "../../components/CardSeplag";
import Status from './componentes/Status'

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
// import { Checkbox } from "primereact/checkbox";
import download from "downloadjs";

import "./style.css";

import CertidoesLoader from "./CertidaoLoader";
import { exportarValidaCertidao } from "../../service/certidao";
import { imprimirValidaCertidao } from "../../service/certidao";
import { Column } from "primereact/column";
import usePermissions from "../../hooks/usePermissions";

const camposTabela = [
  { titulo: "Beneficiário", nome: "nomeAbreviadoCs" },
  { titulo: "Matrícula", nome: "numrMatriculaPessoalCs" },
  { titulo: "CPF", nome: "numrCpfCs" },
  { titulo: "Tipo", nome: "tipoCertidao" },
  { titulo: "Nº Certidão de Crédito", nome: "numrCert" },
];

const pageableApi = {
  content: [],
  totalElements: 0
}

const ListaCertidao = () => {
  // const arrayPermission = usePermissions({ nomeTela: 'VALIDARCERTIDAOLEGADA' })

  const dispatch = useDispatch();
  const filterValidaCertidao = useSelector((state) => state.filterValidaCertidaoReducer);

  const count = useSelector((state) => state.counterRequestReducer.counterRequest);
  const isLoading = count > 0;

  const [certidoesApi, setCertidoesApi] = useState(pageableApi)

  const [filtro, setFiltro] = useState(initFiltro);
  const [checkCertidoesNaoEmitidas, setCheckCertidoesNaoEmitidas] = useState(false);

  const { pagina, row } = filterValidaCertidao

  const reduxDispatch = (parmFiltro, pagina, row = 10) => {
    parmFiltro.numrCpfCs = parmFiltro.numrCpfCs ? parmFiltro.numrCpfCs.replace(/[^\w\s]|_/g, "") : parmFiltro.numrCpfCs

    dispatch({
      type: "SETFILTER_VALIDA_CERTIDAO",
      value: {
        filter: { ...parmFiltro },
        pagina,
        row
      }
    });
  }

  function handleBuscar(filtro, paginacao) {
    buscaCertidoesLegadas(filtro, paginacao).then((res) => {
      setCertidoesApi(res)
    });
  }

  useEffect(() => {

    let filtroPage = `page=${pagina ? pagina : 0}`;
    let filtroSize = `size=${row ? row : 10}`

    let paginacao = `${filtroPage}&${filtroSize}`;

    handleBuscar(filterValidaCertidao.filter, paginacao)
    setFiltro(filterValidaCertidao.filter)

  }, []);


  const HandleBotaoVisualizar = (rowData) => {
    return (
      <>
        {/* {
          arrayPermission.includes('VALIDAR') &&
          <Link to={`/certidao/${rowData.idenValidaCertidaoLegada}`}>
            <Button className="p-button-warning" icon="pi pi-eye" />
          </Link>
        } */}
        {
          <Link to={`/certidao/${rowData.idenValidaCertidaoLegada}`} >
            <Button className="p-button-warning" icon="pi pi-eye" />
          </Link>
        }
      </>
    );
  };

  const handlePaginacao = async (event) => {

    let paginacao = `size=${event.rows}&page=${event.page}`;

    let FLAG_QUITADO_FOLHA_ARCH = filtro.flagQuitadoFolhaArh !== true ? "N" : "S";
    let NUMERO_CERTIDAO = checkCertidoesNaoEmitidas ? "0000000000" : String(filtro.numrCert) === "null" ? null : filtro.numrCert.toString();

    let jsonPost = {
      ...filtro,
      numrCert: NUMERO_CERTIDAO,
      numrCpfCs: filtro.numrCpfCs ? filtro.numrCpfCs.replace(/[^\w\s]|_/g, "") : filtro.numrCpfCs,
      dataEmissaoCert: filtro.dataEmissaoCert !== true ? (filtro.dataEmissaoCert = null) : filtro.dataEmissaoCert,
      dataQuitacaoCert: filtro.dataQuitacaoCert !== true ? (filtro.dataQuitacaoCert = null) : filtro.dataQuitacaoCert,
      dataCompensCert: filtro.dataCompensCert !== true ? (filtro.dataCompensCert = null) : filtro.dataCompensCert,
      dataAutenticCert: filtro.dataAutenticCert !== true ? (filtro.dataAutenticCert = null) : filtro.dataAutenticCert,
      flagQuitadoFolhaArh: FLAG_QUITADO_FOLHA_ARCH,
    };

    buscaCertidoesLegadas(jsonPost, paginacao).then((res) => {
      setCertidoesApi(res)
      reduxDispatch(filtro, event.page, event.rows, res)
    });


  };

  const setarFiltro = ({ target }, isCheckBox = false) => {
    if (isCheckBox) {
      setFiltro((old) => {
        return {
          ...old,
          [target.name]: target.checked,
        };
      });
    } else {
      setFiltro((old) => {
        return {
          ...old,
          [target.name]: target.value,
        };
      });
    }
  };

  function filtrar(event) {
    event.preventDefault();

    let FLAG_QUITADO_FOLHA_ARCH = filtro.flagQuitadoFolhaArh !== true ? "N" : "S";
    let NUMERO_CERTIDAO = checkCertidoesNaoEmitidas ? "0000000000" : String(filtro.numrCert) === "null" ? null : filtro.numrCert.toString();

    let jsonPost = {
      ...filtro,
      numrCert: NUMERO_CERTIDAO,
      numrCpfCs: filtro.numrCpfCs ? filtro.numrCpfCs.replace(/[^\w\s]|_/g, "") : filtro.numrCpfCs,
      dataEmissaoCert: filtro.dataEmissaoCert !== true ? (filtro.dataEmissaoCert = null) : filtro.dataEmissaoCert,
      dataQuitacaoCert: filtro.dataQuitacaoCert !== true ? (filtro.dataQuitacaoCert = null) : filtro.dataQuitacaoCert,
      dataCompensCert: filtro.dataCompensCert !== true ? (filtro.dataCompensCert = null) : filtro.dataCompensCert,
      dataAutenticCert: filtro.dataAutenticCert !== true ? (filtro.dataAutenticCert = null) : filtro.dataAutenticCert,
      flagQuitadoFolhaArh: FLAG_QUITADO_FOLHA_ARCH,
    };

    // let paginacao = `size=${event.rows}&page=${event.page}`;
    let paginacao = `page=0&size=${row}`;

    // for (let key of Object.keys(jsonPost)) {
    //   if (jsonPost[key]) {
    //     if (key === "numrCpfCs") {
    //       paginacao += `&${key}=${jsonPost[key] ? jsonPost[key].replace(/[^\w\s]|_/g, "") : jsonPost[key]}`;
    //     } else {
    //       paginacao += `&${key}=${jsonPost[key]}`;
    //     }
    //   }
    // }



    buscaCertidoesLegadas(jsonPost, paginacao).then((res) => {
      setCertidoesApi(res)
      reduxDispatch(filtro, 0, row, res)
    });
  }

  const handleExportarCertidoes = async () => {
    const payload = {
      nomeAbreviadoCs: filtro.nomeAbreviadoCs,
      numrCpfCs: filtro.numrCpfCs === 0 || filtro.numrCpfCs === "" ? "" : Number(filtro.numrCpfCs.replace(/[^\w\s]|_/g, "")),
      numrMatriculaPessoalCs: filtro.numrMatriculaPessoalCs,
      numrCert: filtro.numrCert,
    };

    const response = await exportarValidaCertidao(payload);

    download(`data:application/excel;base64,${response.dadosRelatorioBase64}`, response.nomeArquivo, "application/excel");
  };

  const handleImprimirCertidoes = async () => {
    const payload = {
      nomeAbreviadoCs: filtro.nomeAbreviadoCs,
      numrCpfCs: filtro.numrCpfCs === 0 || filtro.numrCpfCs === "" ? "" : Number(filtro.numrCpfCs.replace(/[^\w\s]|_/g, "")),
      numrMatriculaPessoalCs: filtro.numrMatriculaPessoalCs,
      numrCert: filtro.numrCert,
    };

    const response = await imprimirValidaCertidao(payload);

    download(`data:application/pdf;base64,${response.dadosRelatorioBase64}`, response.nomeArquivo, "application/pdf");
  };

  const statusBodyTemplate = (rowData) => {

    if (rowData == undefined) return <> </>;

    let cpf = ''
    let nome = ""
    let numrCert = ""

    //importado
    //flagCertidao
    let flagImportado = rowData.flagObrigacao == 'S'
    if (flagImportado) {
      cpf = rowData.numrCpf
      nome = rowData.nomePessoa
      numrCert = rowData.numrCert

    }
    //Validado Beneficiario
    let flagValidadoBeneficiario = rowData.nomePessoa && rowData.numrCpf ? true : false

    //Validado Certidao
    let flagValidadoCertidao = rowData.tipoCertidaoValidada && rowData.amparoLegalObrigacao && rowData.orgao

    return <Status
      flagValidadoCertidao={flagValidadoCertidao}
      flagValidadoBeneficiario={flagValidadoBeneficiario}
      flagImportado={flagImportado}
      numrCpf={cpf}
      nomePessoa={nome}
      numrCert={numrCert}
    />


  }


  return (
    <CardSeplag title="Validação">
      {isLoading && <CertidoesLoader />}

      {!isLoading && (
        <form onSubmit={filtrar} className="p-col-12">
          <div className="p-col p-grid">

            <RotuloSeplag nome="Beneficiário" cols="12 3">
              <InputText name="nomeAbreviadoCs" id="nomeAbreviadoCs" value={filtro.nomeAbreviadoCs} style={{ width: "100%" }} onChange={(e) => setarFiltro(e)} />
            </RotuloSeplag>

            <RotuloSeplag nome="CPF" cols="12 3">
              <InputMask mask="999.999.999-99" name="numrCpfCs" value={filtro.numrCpfCs} onChange={(e) => setarFiltro(e)} id="input_filtro" />
            </RotuloSeplag>

            <RotuloSeplag nome="Matrícula" cols="12 3">
              <InputText name="numrMatriculaPessoalCs" value={filtro.numrMatriculaPessoalCs} style={{ width: "100%" }} onChange={(e) => setarFiltro(e)} />
            </RotuloSeplag>

            <RotuloSeplag nome="Nº Certidão de Crédito" cols="12 3">
              <InputText disabled={checkCertidoesNaoEmitidas ? true : false} name="numrCert" id="numrCert" value={filtro.numrCert} style={{ width: "100%" }} onChange={(e) => setarFiltro(e)} />
            </RotuloSeplag>

            <RotuloSeplag nome="" cols="12 4">
              <div style={{ display: "flex", paddingTop: "19px" }}>
                <Button label="Filtrar" icon="pi pi-search" className="p-button-raised" onClick={filtrar} style={{ marginRight: "5px", width: "10rem" }} />
              </div>
            </RotuloSeplag>
          </div>
        </form>
      )}
      <TableSeplag
        dados={certidoesApi.content}
        totalRecords={certidoesApi.totalElements}
        camposTabela={camposTabela}
        hasEventoAcao
        botoesAcoes={HandleBotaoVisualizar}
        onPage={handlePaginacao}
        page={pagina}
        rows={row}
        onImprimir={handleImprimirCertidoes}
        onExportar={handleExportarCertidoes}
        onModalSearch
      >

        <Column
          field="status"
          header="Status"
          className="columnStatus"
          body={statusBodyTemplate}
        />

      </TableSeplag>
    </CardSeplag>
  );
};

export default ListaCertidao;
